import { IUserAlertPreferences } from 'common/src/types/interfaces';

import { trackPendoEvent } from 'portal/src/utils/pendo';

import { diffAlertPreferences } from './helpers';

export const trackAlertPreferenceChanges = ({
  original,
  updated,
  targetUserId,
  editedSelf,
}: {
  original: Array<Partial<IUserAlertPreferences>>;
  updated: Array<Partial<IUserAlertPreferences>>;
  targetUserId?: string;
  editedSelf: boolean;
}) => {
  const changes = diffAlertPreferences(original, updated);

  if (changes.length === 0) return;

  changes.forEach((change) => {
    trackPendoEvent('AlertPreferenceChanged', {
      alertType: change.type,
      alertSubtype: change.subtype,
      enabledBefore: change.enabledBefore,
      enabledAfter: change.enabledAfter,
      frequencyBefore: change.frequencyBefore,
      frequencyAfter: change.frequencyAfter,
      enabledChanged: change.enabledChanged,
      frequencyChanged: change.frequencyChanged,
      targetUserId,
      editedSelf,
    });
  });

  const enabledChanges = changes.filter((change) => change.enabledChanged);
  const typesAffected = new Set(changes.map((change) => change.type));

  trackPendoEvent('AlertPreferencesSaved', {
    subtypesChanged: changes.length,
    subtypesEnabled: enabledChanges.filter((change) => change.enabledAfter)
      .length,
    subtypesDisabled: enabledChanges.filter((change) => !change.enabledAfter)
      .length,
    frequencyChanges: changes.filter((change) => change.frequencyChanged)
      .length,
    typesAffected: typesAffected.size,
    targetUserId,
    editedSelf,
  });
};
